import { Mention } from './Mention';
import { withMentions } from './utils';
const MentionPlugin = ({ className = '', handleMentionKeyEvent = () => { }, ...attributes } = {}) => ({
    renderElement: Mention({ className, ...attributes }),
    with: withMentions,
    onKeyDown: handleMentionKeyEvent,
});
export { MentionPlugin };
//# sourceMappingURL=MentionPlugin.js.map